import smetaAxios from "../../../SmetaAxios";
import { createGrid, createRecordSource } from "../rcsgrid";

export async function dbviewGrid(
  grid: createGrid,
  source: createRecordSource,
  props: { Module: string },
  data: { id: string },
) {
  source.onHandleRequest = handleRequest(props, data);
  await source.open();
  grid.defaultColumns = true;
  await grid.setSource(source);
  await grid.updateGridSize();
}

function handleRequest(props: { Module: string }, data: { id: string }) {
  return (request) => {
    return smetaAxios.post("HandleTable", request, {
      prefix: props.Module,
      params: { ID: data.id, Refresh: request.command === "getFields" ? 1 : 0 },
      loadMask: true,
    });
  };
}
